import { render } from "./LoadInfo.vue?vue&type=template&id=b59e7e8c&scoped=true"
import script from "./LoadInfo.vue?vue&type=script&lang=js"
export * from "./LoadInfo.vue?vue&type=script&lang=js"

import "./LoadInfo.vue?vue&type=style&index=0&id=b59e7e8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59e7e8c"]])

export default __exports__